export const LOAD_REGISTERTOKENS = (registerTokens) => {
    return {type: "LOAD_REGISTERTOKENS", registerTokens}
}